(function ($, Drupal, drupalSettings, once) {

  /**
   * All functionality for the mega menu
   *
   * @type {{attach: attach}}
   */
  Drupal.behaviors.megaMenu = {
    attach: function attach(context) {
      const openClass = 'open';
      const hoveredClass = 'hovered-open';
      const colLinkedClass = 'col-linked';
      const initialFirst = 'initial-group';
      const initialSecond = 'initial-second-group';
      const megaWrap = '.menu--simple-mega-menu .mega-menu-wrapper';
      const colFirst = '.menu--simple-mega-menu .col-1';
      const colSecond = '.menu--simple-mega-menu .col-2';
      const liParent = '.menu--simple-mega-menu .view-grouping-level-0';
      const liFirst = colFirst + ' .view-grouping-level-0';
      const liSecond = colSecond + ' .view-grouping-level-0';
      const colLinked = '.menu--simple-mega-menu .' + colLinkedClass;
      const liLinked = liParent + '.' + colLinkedClass;

      $(liFirst + ':first-child').addClass(initialFirst);
      $(liSecond + ':first-child').addClass(initialSecond);

      //Open and Close mega menu content
      $('.menu--simple-mega-menu').on('click', function (e) {
        if ($(this).hasClass(hoveredClass)) {
          $(this).removeClass(hoveredClass);
        }
        $(this).parent().removeClass(hoveredClass).addClass(hoveredClass);
      });

      // Show child menu of 'group-0' li
      $(once('show-groups', liFirst)).each(function () {
        $(this).on('click', function (e) {

          $(this).parent().children('.' + openClass).removeClass(openClass);
          $(this).closest('.menu--simple-mega-menu').find('.col-2').removeClass(openClass);

          $(this).addClass(openClass);

          if (!$(this).hasClass(colLinkedClass) && !$(this).hasClass(initialFirst) && !$(this).parents(colFirst).hasClass('interacted-view')) {
            $(this).parents(colFirst).addClass('interacted-view');
          };

          if ($(this).hasClass(colLinkedClass)) {
            $(this).parents(colFirst).addClass('interacted-view');
            $(this).closest('.menu--simple-mega-menu').find('.col-2').addClass(openClass);
          }

          if ($(this).hasClass(initialFirst)) {
            $(this).parents(colFirst).removeClass('interacted-view');
          }
          e.stopPropagation();
        });
      });

      // Show more menus in col-2
      $(once('show-first-groups', liSecond)).each(function () {
        $(this).on('click',function (e) {
          if (!$(this).hasClass(initialSecond)) {
            $(this).parents(colSecond).addClass('interacted-view');
          } else {
            $(this).parents(colSecond).removeClass('interacted-view');
          }
          $(this).parent().children('.' + openClass).removeClass(openClass);
          $(this).addClass(openClass);

          e.stopPropagation();
        });
      });

      // Auto-height child grouping for procedures
      $('.view-procedure-menu .view-grouping-level-0 > .view-grouping-content').matchHeight();
      $('.view-procedure-menu').height($('.view-procedure-menu .view-grouping-level-0 > .view-grouping-content').height());

      // Handle the inner menu "forward" button, the grouping header
      $(once('mega-forward-mobile', liParent + ' > .view-grouping-header')).each(function () {
        $(this).on('click', function () {
          $(this).parents('.view-content').find('.view-grouping-level-0')
            .removeClass('clicked-open')
            .addClass('not-clicked-open');
          $(this).parent()
            .removeClass('not-clicked-open')
            .addClass('clicked-open');
          // ... and remove the back button/parent for the main parent
          $(this).parents('.menu--simple-mega-menu').addClass('child-clicked-open');
        });
      });

      // Handle the inner menu back button
      $(once('mega-back-mobile', '.dropdown-inner-back')).each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          $(liParent)
            .removeClass('clicked-open')
            .removeClass('not-clicked-open');
          // ... and re-add the back button/parent for the main parent
          $(this).parents('.menu--simple-mega-menu').removeClass('child-clicked-open');
        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once);